module.exports = __webpack_public_path__ + "img/filing.d0289dc0.png";